import {
	isProductKey,
	type PrimaryProductKey,
	type ProductKeys,
} from '../../common/constants/products';
import { SearchExperience, type SearchStoreExperience } from '../../common/constants/search';

export const getProductToSelect = (params: {
	isUniversal?: boolean;
	primaryProduct?: PrimaryProductKey;
	productToSet?: ProductKeys;
	selectedProduct?: ProductKeys;
	experience?: SearchStoreExperience;
}) => {
	if (
		params.productToSet ||
		(params.isUniversal &&
			// Universal Filters on Quick Find selects the primaryProduct until we do cross product search
			//https://atlassian.slack.com/archives/C050EC6FM28/p1763330594902229?thread_ts=1763092320.695409&cid=C050EC6FM28
			params.experience !== SearchExperience.QUICK_FIND)
	) {
		return params.productToSet;
	}

	const productToSelect = params.selectedProduct ?? params.primaryProduct ?? '';
	const safeProductKey = isProductKey(productToSelect) ? productToSelect : undefined;
	return safeProductKey;
};
